import { FOR_YOU } from '@/constants/tabConfig';
import { EmptyState } from '../EmptyState';
import { USE_DEFAULT_EMPTY_STATE } from '../EmptyState/EmptyState';

export const NoEventsEmptyState = () => {
    return (
        <EmptyState
            bucketKey={FOR_YOU}
            emptyState={[
                { validation: { shouldShowEmptyState: true }, config: USE_DEFAULT_EMPTY_STATE },
            ]}
        />
    );
};
